export default __webpack_public_path__ + "b7ddfa4e8159986c3cb9a7de541c6b46.png";